export default "__VITE_ASSET__Bf14G0Cr__"